import React from 'react';
import { useSelector } from 'react-redux';
import FormWrapperTitle from '../../../../../UI/Wrapper/Form/FormWrapperWithTitle';
import useUtilStyles from '../../../../../../helpers/styles/utils.styles';
import {
  useCrudClienteSelector,
} from '../../../../../../store/Cliente/V2/Crud/CrudClienteProvider';
import Grid24 from '../../../../../UI/Grid24';
import SelectorField from '../../../../../UI/Field/Selector';
import WrapperSubTitleForm from '../../../../../UI/WrapperSubTitleForm';
import { getRequiredLabel } from '../../../../../../helpers';

function EnvioRelatorioParaCliente({
  onChangeInputFields,
  onFocus,
  disabled,
}) {
  const utilStyle = useUtilStyles();

  const idFrequenciaRelatorioBaixa = useCrudClienteSelector(states => states.controls.idFrequenciaRelatorioBaixa.copy());
  const idFrequenciaRelatorioPosicaoCobranca = useCrudClienteSelector(states => states.controls.idFrequenciaRelatorioPosicaoCobranca.copy());
  const idQtdeHistoricoPosicaoCobranca = useCrudClienteSelector(states => states.controls.idQtdeHistoricoPosicaoCobranca.copy());
  const frequenciaRelatorioList = useSelector(states => states.selectors.frequenciaRelatorioList.selector);
  const qtdeHistoricoList = useSelector(states => states.selectors.qtdeHistoricoList.selector);

  return (
    <FormWrapperTitle title="Configuração de Envio de Relatório para o Cliente">
      <WrapperSubTitleForm title="Relatório de Baixa">
        <Grid24 isFormContainer container spacing="1" className={utilStyle.mt16}>
          <Grid24 xs={24} sm={2}>
            <SelectorField
              isForm
              items={frequenciaRelatorioList}
              name={idFrequenciaRelatorioBaixa.name}
              value={idFrequenciaRelatorioBaixa.value}
              error={idFrequenciaRelatorioBaixa.error}
              errorMessage={idFrequenciaRelatorioBaixa.errorMessage}
              label={getRequiredLabel('Periodicidade', !disabled)}
              onChange={onChangeInputFields}
              disabled={disabled}
              onFocus={onFocus}
            />
          </Grid24>
        </Grid24>
      </WrapperSubTitleForm>
      <hr className={utilStyle.divider} />
      <WrapperSubTitleForm title="Relatório Posição de Cobrança e Conta Corrente">
        <Grid24 isFormContainer container spacing="1" className={utilStyle.mt16}>
          <Grid24 xs={24} sm={2}>
            <SelectorField
              isForm
              items={frequenciaRelatorioList}
              name={idFrequenciaRelatorioPosicaoCobranca.name}
              value={idFrequenciaRelatorioPosicaoCobranca.value}
              error={idFrequenciaRelatorioPosicaoCobranca.error}
              errorMessage={idFrequenciaRelatorioPosicaoCobranca.errorMessage}
              label={getRequiredLabel('Periodicidade', !disabled)}
              onChange={onChangeInputFields}
              disabled={disabled}
              onFocus={onFocus}
            />
          </Grid24>
          <Grid24 xs={24} sm={3}>
            <SelectorField
              isForm
              items={qtdeHistoricoList}
              name={idQtdeHistoricoPosicaoCobranca.name}
              value={idQtdeHistoricoPosicaoCobranca.value}
              error={idQtdeHistoricoPosicaoCobranca.error}
              errorMessage={idQtdeHistoricoPosicaoCobranca.errorMessage}
              label={getRequiredLabel('Quantidade de históricos', !disabled)}
              onChange={onChangeInputFields}
              disabled={disabled}
              onFocus={onFocus}
            />
          </Grid24>
        </Grid24>
      </WrapperSubTitleForm>
    </FormWrapperTitle>
  );
}

export default EnvioRelatorioParaCliente;
